// pages/ConversationsListPage.js
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Markdown from "../components/Markdown";
import apiClient from "../utils/apiClient";
import SubscribeBanner from "../components/SubscribeBanner";


export default function ConversationsListPage() {
  const [conversations, setConversations] = useState([]);
  const [page,        setPage]          = useState(1);
  const [totalPages,  setTotalPages]    = useState(1);
  const [loading,     setLoading]       = useState(false);
  const navigate = useNavigate();

  const fetchPage = async (p) => {
    setLoading(true);
    try {
      const res = await apiClient.get("/conversations", {
        params: { page: p, limit: 20 }
      });
      const { data, totalPages: tp } = res.data;
      // if p===1, replace; else append
      setConversations(cd => p === 1 ? data : [...cd, ...data]);
      setTotalPages(tp);
    } catch (err) {
      console.error("Failed to load conversations", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    //apiClient.get(`/conversations`).then(res => setConversations(res.data));
    fetchPage(1);
  }, []);

  const handleLoadMore = () => {
    if (page < totalPages && !loading) {
      const next = page + 1;
      setPage(next);
      fetchPage(next);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 mt-10 space-y-4 mb-4">
      <SubscribeBanner msg={"Unlock your full conversation history, unlimited recipes and more with a Pro subscription."}/>
  <h1 className="text-2xl font-bold">My Conversations</h1>

  {conversations.map((convo) => (
    <div
      key={convo._id}
      onClick={() => navigate(`/chat/${convo._id}`)}
      className="border p-4 rounded shadow hover:shadow-md cursor-pointer"
    >
      <p className="font-semibold mb-2">
        {convo.title || new Date(convo.updatedAt).toLocaleString()}
      </p>

      {/* Message preview box */}
      <div className="relative max-h-[150px] overflow-hidden pr-2">
        <div className="space-y-3">
          {convo.messages.slice(0, 3).map((m, i) => (
            <div
              key={i}
              className={`flex ${m.role === "user" || m.role === "image" ? "justify-end" : "justify-start"}`}
            >
              <div
                className={`relative px-3 py-2 max-w-[80%] text-sm rounded-2xl ${
                  m.role === "user" || m.role === "image"
                    ? "bg-blue-100 text-left rounded-br-sm"
                    : "bg-gray-100 text-left rounded-bl-sm"
                }`}
              >
                {m.role === "user" || m.role === "assistant" ? (
                <Markdown content={m.content} /> 
                ) : m.role === "image" ? (
                  <div className="relative px-4 py-2 max-w-[80%] rounded-2xl bg-blue-100 text-left rounded-br-sm">
                  <img src={m.content} alt="Uploaded image" className="w-full rounded shadow mt-2" />
                 </div>
                ) : null }
              </div>
            </div>
          ))}
        </div>

        {/* Fade out effect */}
        <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-transparent pointer-events-none" />
      </div>
    </div>
  ))}

        {/* Load more button */}
        {page < totalPages && (
        <div className="text-center">
          <button
            onClick={handleLoadMore}
            disabled={loading}
            className="px-6 py-2 bg-sage text-white rounded hover:hover:bg-sagedark disabled:opacity-50"
            
          >
            {loading ? "Loading…" : "Load more"}
          </button>
        </div>
      )}
</div>

  );
}
